import { DisabledTooltip } from 'modules/experiments/components/pages/CommonStyled';

export const TooltipWrapper: React.FC<
  React.PropsWithChildren<{ tooltipContent: React.ReactNode }>
> = ({ children, tooltipContent }) =>
  tooltipContent ? (
    <DisabledTooltip tooltipContent={tooltipContent}>{children}</DisabledTooltip>
  ) : (
    <>{children}</>
  );
